<template>
        <div   :style="'height:'+ innerHeight + 'px;'">
             <div class="e u-center">
                     <div class="login-content">
                         <div :style="`flex:1;background-image: url(${login_bg});` " class="login-bg"></div>
                         <div style="flex:1;" class="u-center">
                             <div>
                                 <div style="text-align: center;font-size:18px">
                                    欢迎登陆
                                 </div>
                                 <div class="input-block">
                                     <div class="label-style">所属公司</div>
                                     <Select v-model="formInline.platform_index"  >
                                         <Option v-for="(item, index) in platform_list" :value="index" :key="index">{{ item.name }}</Option>
                                     </Select>
                                 </div>
                                 <div class="input-block">
                                     <div class="label-style">账户</div>
                                     <Input type="text" v-model="formInline.mobile" placeholder="请输入登录账户" />
                                 </div>
                                 <div class="input-block">
                                     <div class="label-style">密码</div>
                                    <Input type="password" v-model="formInline.pwd" placeholder="请输入密码" />
                                 </div>
                                <div class="login-btn">
                                    <Button type="primary"  @click="handleSubmit">立即登录</Button>
                                </div>

                             </div>
                         </div>

                     </div>
             </div>
        </div>
</template>
<script>
    import {login} from '@/api/system'
    import {setCookies, getCookies} from '@/utils/helper'
import {windowsRise} from '@/utils/dom';
    export default {
        data () {
            return {
                login_bg:require('../../assets/login.png'),
                innerHeight: 0,
                formInline: {
                    mobile: '',
                    pwd: '',
                    platform_id:1,
                    platform_index:0
                },
                platform_list:[
                    {id:1, name:'勺子同学'},
                    {id:2, name:'互联造物'}
                ]
            }
        },
        created(){
            let host = location.hostname
            if (host == 'crm.crmhulianzaowu.cn') {
                this.formInline.platform_index = 1
                this.formInline.platform_id = 2
            }
            
            if(getCookies('mobile')) {
                this.formInline.mobile = getCookies('mobile')
                this.formInline.pwd = getCookies(this.formInline.mobile)
            }
        },
        mounted(){
            this.restHeight();
            windowsRise(window, this.restHeight);
            // this.$store.commit('setUserInfo', {id:1});
            var _this = this
            document.onkeydown = function () {
                if (_this.$route.path === '/login') {
                    if (window.event.keyCode === 13) {
                        _this.handleSubmit()
                    }
                }
            }
        },
        methods: {
            /**修改高度 */
            restHeight(){
                this.innerHeight =  window.innerHeight - 2;
                console.log(this.innerHeight)
            },

            handleSubmit(){
                let index = this.platform_list[this.formInline.platform_index]
                this.formInline.platform_id = index.id
                login(this.formInline).then(res=>{
                    console.log(res)
                    if (res.code === 200) {
                        this.$store.commit('setUserInfo', res.data);
                        this.$store.commit('setPlatformInfo', index);
                        setCookies('mobile', this.formInline.mobile)
                        setCookies(this.formInline.mobile, this.formInline.pwd)
                        setCookies('token', res.data.token)
                        // if ( res.data.role == 1 ||res.data.role == 4 ) {
                        //     return this.$router.replace({path: '/aftersale'})
                        // }
                        // if ( res.data.role == 3 ) {
                        //     return this.$router.replace({path: '/success'})
                        // }
                        if(this.$route.query.from == 'h5'){
                            return this.$router.replace({path: `/customerpool/info?order_id=${this.$route.query.order_id}&customer_id=${this.$route.query.customer_id}&type=6&from=h5`})
                        }
                        return this.$router.replace({path: '/customerpool/index'})

                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .u-center{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .e{
        margin-top:-20px;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 999;
    }
    .login-content{
        display: flex; width:800px;height:500px;
        border: 1px solid #eeeeee;
        background: #ffffff;
        border-radius: 24px;
        color:#0A1629;
    }
    .login-bg{
        width:100%;
        height:500px;
        background-size:100% 100%;
        background-repeat: no-repeat;
        border-bottom-left-radius: 24px;
        border-top-left-radius: 24px;
    }
    .label-style{
        font-size:12px;
        margin-bottom: 5px;
        color:#445E87;
    }
    .login-btn{
        text-align: center;margin-top:20px
    }
    .login-btn .ivu-btn-primary{
        font-size: 10px;
        padding:0 30px;
        box-shadow: 0px 2px 3px 2px #e5eaef;
    }
    .input-block{
        margin-top:20px;
        width:240px
    }
    .forget-pwd{
        text-align: right;
        cursor: pointer;
        color:#445E87;
        font-size: 13px;
    }
</style>
